module.exports = __webpack_public_path__ + "img/w-offline-adv.fa693eff.svg";